export enum ActionsPlaceholderSettings {
	NotificationDisabled = 'You do not perform this activity.\nNo actions are available.',
	JobAutoSkipped = 'Your Site does not perform this activity.\nNo actions are available.',
	BothDisabled = 'Neither you nor your Site perform this activty.\nNo actions are available.'
}
